export const search = "Explore a specific tropical area through the searchbar";
export const zoom = "Zoom in & out";
export const method = "Understand methodology";
export const report = "Report an Issue";
export const dwnld = "Download datasets and discover statistics";
